import {
  ControllerSectionedMenu,
  ControllerSectionedMenuProps,
} from '@bymason-private/legacy-pattern-components';
import { ControllerNavAction } from '../types';

export default function ResourcesMenu(
  props: Omit<ControllerSectionedMenuProps<ControllerNavAction>, 'sections'>
) {
  return (
    <ControllerSectionedMenu<ControllerNavAction>
      {...props}
      sections={[
        {
          caption: 'Resources',
          items: [
            {
              id: ControllerNavAction.ResourcesQuickstart,
              href: 'https://docs.bymason.com/setup-guide?utm_source=Controller&utm_medium=Referral',
              text: 'Getting Started Guide',
            },
            {
              id: ControllerNavAction.ResourcesDocs,
              href: 'https://docs.bymason.com/?utm_source=Controller&utm_medium=Referral',
              text: 'Documentation',
            },
          ],
        },
        {
          caption: 'OtherResources',
          hideCaption: true,
          items: [
            {
              id: ControllerNavAction.ResourcesDevKits,
              text: 'Buy Dev Kits',
            },
            {
              id: ControllerNavAction.ResourcesByMason,
              href: 'https://bymason.com/?utm_source=Controller&utm_medium=Referral',
              text: 'bymason.com',
            },
          ],
        },
        {
          caption: 'Help',
          items: [
            {
              id: ControllerNavAction.ResourcesContactSupport,
              text: 'Contact Support',
            },
          ],
        },
      ]}
    />
  );
}
